import { render, staticRenderFns } from "./ModelosFormularioTR.vue?vue&type=template&id=bd96631a&scoped=true"
import script from "./ModelosFormularioTR.vue?vue&type=script&lang=js"
export * from "./ModelosFormularioTR.vue?vue&type=script&lang=js"
import style0 from "./ModelosFormularioTR.vue?vue&type=style&index=0&id=bd96631a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd96631a",
  null
  
)

export default component.exports